module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col title"
  }, [_vm._v("Publication Ethics and Publication Malpractice Statements")]), _vm._v(" "), _c('div', {
    staticClass: "col-3 pl-1 hidden-md-up"
  }, [_c('for-authors-mobile-menu', {
    attrs: {
      "anchors-list": _vm.anchorsList
    }
  })], 1)]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.siteName) + "\n    "), _c('br'), _vm._v(" "), _vm._v("\n    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapienLorem ipsum dolor sit amet, consectetur adipiscing elit.\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b91c9e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/for-authors/for-authors-policies/EthicsMalpracticeContent.vue
// module id = 1397
// module chunks = 1